import {MenuActionFormType} from "../Forms/AutoAttendantsMenus/ActionsForm.utils";
import {MenuAction, UserInput} from "../../store/types/AutoAttendant";
import {makeStyles} from "@material-ui/core";
import {Colors} from "../../styles/Colors";
import * as Yup from "yup";
import i18n from "../../services/i18n";

export const initialValuesMenuActionForm: MenuActionFormType = {
    timeout: '0',
    announceExtensionNumbers: false,
    playBeforeActionStatus: false,
    playBeforeActionFileName: '',
    playBeforeActionFile: null,
    transferCallerToPhoneNumberExtension: '',
    maxDigits: '4',
    action: MenuAction.DoNothing,
};

export interface MenuActionDialogProps {
    isOpen: boolean;
    toggleVisibility?: () => void;
    menuActions: MenuActionFormType[];
    initialValue?: MenuActionFormType;
    onSave?: (form: MenuActionFormType) => void;
    isDialExtensionDirectlyBlocked?: boolean;
    deleteAction?: (action: MenuActionFormType) => void;
}

export const useStyles = makeStyles(() => ({
    buttonFile: {
        marginRight: '0px',
        width: 'auto',
        flex: 1
    },

    buttonFileTextField: {
        maxWidth: 296,
        width: 296,
        flex: 1
    },

    itemsContainer: {
        padding: '0 38px 18px 28px',
        display: 'flex',
        flexDirection: 'column',
    },

    sectionMargin: {
        marginTop: 16
    },
    header: {
        '& .MuiTypography-h6': {
            fontWeight: 'bold',
            fontSize: 18,
        },
    },
    modalContainer: {
        '& .MuiDialogContent-root': {
            background: Colors.SmokeBackground,
            width: 520,
            height: 450,
            padding: '26px 60px 40px 60px',
        },

        '& .MuiDialogActions-root': {
            justifyContent: 'space-between',
            paddingLeft: 50,
        },
    },
    customOptionContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
    },
    customOptionSemiValue: {
        fontSize: 14,
        color: Colors.Gray,
    },
    option: {
        height: '48px !important',
    },
    tooltipIcon: {
        marginLeft: 10,
    },
    didNumbers: {
        height: 'auto',
        minHeight: 60,

        '& .MuiInputBase-root': {
            paddingBottom: 5,
            minHeight: 60,
            height: 'auto',
            paddingTop: 25,
        },
        '& .MuiAutocomplete-endAdornment': {
            top: 'unset',
            bottom: 14,
        },
    },
    didNumbersIconContainer: {
        alignItems: 'flex-end',
        paddingBottom: 16,
    },
    fieldMargin: {
        marginBottom: 25,
    },
    centeredGrid: {
        display: 'flex',
        alignItems: 'center',
    },
    playBeforeGrid: {
        margin: '15px 0',
    },
    numberPickerGrid: {
        marginTop: 15,
        '& .MuiFormControl-root': {
            flex: 'unset',
        },
    },
    numberInput: {
        width: 135,
        marginRight: 20,
        whiteSpace: 'nowrap'
    },
    selectMargin: {
        marginTop: 15,
        width: '100%'
    },
    removeButton: {
        color: Colors.Gray5,
        display: 'flex',
        alignItems: 'center',

        '& .MuiSvgIcon-root': {
            marginRight: 5,
        },
    },
    saveButtonDisabled: {
        backgroundColor: `${Colors.Gray8}!important`,
        '& .MuiButton-label': {
            color: `${Colors.Gray10}!important`,
        },
    },
    fileWrapper: {
        width: '100%',
        flex: 1

    },
    saveButton: {
        marginLeft: 16,
    },
    buttons: {
        display: 'flex',
        alignItems: 'center',
    },
}));
export const availableListForDialExtensionDirectly = [
    UserInput.Digit0,
    UserInput.Digit1,
    UserInput.Digit2,
    UserInput.Digit3,
    UserInput.Digit4,
    UserInput.Digit5,
    UserInput.Digit6,
    UserInput.Digit7,
    UserInput.Digit8,
    UserInput.Digit9,
];
export const faxActions = [
    MenuAction.DoNothing,
    MenuAction.DisconnectCall,
    MenuAction.TransferToFaxMailbox,
];
const requiredError = i18n.t<string>('errors:common.emptyInput');
const transferDestinationValidation = i18n.t(
    'errors:extensions.transferDestination',
);
const number = i18n.t('errors:extensions.e164Number');
export const MenuActionValidationSchema = Yup.object().shape({
    playBeforeActionStatus: Yup.boolean().required(),
    playBeforeActionFileName: Yup.string().notRequired(),
    menu: Yup.object().when('action', {
        is: (value: unknown) => value === MenuAction.Menu,
        then: Yup.object().required(requiredError),
        otherwise: Yup.object(),
    }),
    transferCallerToPhoneNumberExtension: Yup.string()
        .when('action', {
            is: (value: unknown) =>
                value === MenuAction.Transfer ||
                value === MenuAction.TransferToE164Number,
            then: Yup.string().required(requiredError),
            otherwise: Yup.string(),
        })
        .when('action', {
            is: (value: unknown) => value === MenuAction.TransferToE164Number,
            then: Yup.string()
                .matches(/^[A-Da-d0-9*#]+$/, i18n.t<string>(number))
                .min(7, transferDestinationValidation)
                .required(requiredError),
            otherwise: Yup.string(),
        }),
    timeout: Yup.number()
        .when('userInput', {
            is: (value: unknown) =>
                value === UserInput.NoInput,
            then: Yup.number().required(requiredError),
            otherwise: Yup.number().notRequired().nullable(),
        }),
    userInput: Yup.string().required(requiredError),
    action: Yup.string().required(requiredError),
});